<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showcoursecontent") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-lg-12">
            <h3>{{ $t("PLACEHOLDERS.choose_type") }}</h3>

            <div class="type-selector">
              <label
                class="custom-radio"
                :class="{ selected: data.type === 'lecture', disabled: true }"
              >
                <input
                  type="radio"
                  value="lecture"
                  v-model="data.type"
                  disabled
                />
                <span class="radio-label">{{
                  $t("PLACEHOLDERS.lecture")
                }}</span>
              </label>

              <label
                class="custom-radio"
                :class="{ selected: data.type === 'exam', disabled: true }"
              >
                <input type="radio" value="exam" v-model="data.type" disabled />
                <span class="radio-label">{{ $t("PLACEHOLDERS.exam") }}</span>
              </label>
            </div>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
            disabled
          />
          <base-select-input
            v-if="data.type === 'exam'"
            col="6"
            :placeholder="$t('PLACEHOLDERS.exam')"
            v-model.trim="data.exam"
            :optionsList="exams"
            disabled
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.lecture_video')"
            v-model.trim="data.video"
            v-if="data.type === 'lecture'"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.course')"
            v-model.trim="data.course"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.class_name')"
            v-model.trim="data.class"
            required
            disabled
          />

          <base-input
            col="6"
            type="textarea"
            v-if="data.type === 'lecture'"
            :placeholder="$t('PLACEHOLDERS.description')"
            v-model.trim="data.description"
            required
            disabled
          />
          <!-- End:: Name Input -->
          <div class="col-lg-6" v-if="data.type === 'lecture'">
            <h3 class="heading">{{ $t("PLACEHOLDERS.resources") }}</h3>
            <FileUpload
              :multiple="true"
              :preSelectedFile="data.uploadedFile"
              :accept="'application/pdf,image/*,video/*'"
              :urls="preparedUrls"
              @onFileSelect="handleFileSelect"
              @onFileRemove="handleFileRemove"
              disabled
            />
          </div>
          <div
            class="input_wrapper switch_wrapper my-5 col-6"
            v-if="data.type === 'lecture'"
          >
            <v-switch
              color="green"
              disabled
              :label="
                data.can_read
                  ? $t('PLACEHOLDERS.enable_read')
                  : $t('PLACEHOLDERS.disabled_read')
              "
              v-model="data.can_read"
              hide-details
            ></v-switch>
          </div>

          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FileUpload from "../../../components/formInputs/FileUpload.vue";

export default {
  name: "ShowBank",
  components: { FileUpload },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      exams: [],
      preparedUrls: [],
      file: null,
      fileType: "",
      courses: [],
      classes: [],
      data: {
        name_ar: null,
        name_en: null,
        video: null,
        course: null,
        description: "",
        type: "",
        exam: null,
        class: null,
        can_read: true,
      

},
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    handleFileSelect(files) {
      this.selectedFiles = files;
    },
    handleFileRemove(index) {
      this.preparedUrls.splice(index, 1);
    },
    async showCourseContent() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `course-contents/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.CourseContent.name_ar;
        this.data.name_en = res.data.data.CourseContent.name_en;
        this.data.description = res.data.data.CourseContent.description;
        this.data.name_en = res.data.data.CourseContent.name_en;
        this.data.type = res.data.data.CourseContent.type;
        this.data.course = res.data.data.CourseContent.course.name;
        this.data.exam = res.data.data.CourseContent?.exam;

        this.data.class = res.data.data.CourseContent.class_name.name;
        this.data.can_read = res.data.data.CourseContent.can_read;

        this.data.video = res.data.data.CourseContent.video_url;
        this.preparedUrls = res.data.data.CourseContent.sources.map(
          (item) => item.source
        );

        this.data.active = res.data.data.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    async getExams() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `exams?page=0&limit=0&is_active=1`,
        });
        this.exams = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.showCourseContent();
    this.getExams();
  },
};
</script>
